import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { colors } from 'theme/colors';
import Button from 'components/atoms/Button';

const StyledFooter = styled(Grid)`
  height: 64px;
  border-top: 1px solid ${colors.blue200};
  box-shadow: 0 -6px 10px 0 rgba(194, 204, 243, 0.35);

  position: sticky;
  background: white;
  bottom: 0;
  z-index: 999;
`;

const StyledGreenButton = styled(Button)`
  background-color: ${colors.success500};

  & svg {
    color: ${colors.white};
  }

  &:hover {
    background-color: ${colors.success300};
    box-shadow:
      0 0 5px rgba(7, 87, 157, 0.1),
      0 0 10px rgba(5, 58, 104, 0.02);
  }

  &:focus {
    background-color: ${colors.success600};
  }

  &:active {
    background-color: ${colors.success900};
  }
`;

export { StyledFooter, StyledGreenButton };
